import SetupFirstDevice from './setup-first-device';
import Dropdown from 'Components/dropdown';
import Phone from 'Components/phone';
import DeviceService from 'Services/device';
import Search from 'Mixins/search';
import moment from 'moment';
import store from 'store';
import _ from 'lodash';
import Vue from 'vue';

export default {
	name: 'dashboard',
	components: {
		SetupFirstDevice,
		Dropdown,
		Phone
	},
	mixins: [Search],
	beforeCreate() {
		this.$options.filters.capitalize = this.$options.filters.capitalize.bind(this);
		this.$options.filters.model = this.$options.filters.model.bind(this);
	},
	created() {
		this.isCancelled = this.$store.state.user.status === 'cancelled';

		if (this.$route.params.snack === 'confirmed') {
			this.snack.visible = true;
			this.snack.message = 'This account has been already confirmed';
			this.snack.color = '#145cff';
			this.snack.timeout = 6000;
		} else if (this.$route.params.snack === 'error') {
			this.snack.visible = true;
			this.snack.message =
				'To confirm your account please use the latest link received from Webkey. Please take a second and click that link to help us secure your account.';
			this.snack.color = 'red';
			this.snack.timeout = 0;
		}

		if (store.get('prefered-devices-view')) {
			this.view = store.get('prefered-devices-view');
		}

		this.$store.dispatch('updateDevices');

		this.polling = setInterval(() => {
			if (this.isBackendSearchUsed && this.isTyping) {
				return;
			}
			this.$store.dispatch('updateDevices', { search: this.isBackendSearchUsed ? this.currentFilter : '' });
		}, parseInt(process.env.DEVICE_POLING_TIME, 10) || 10000);

		this.onFilterInput = _.debounce(this.searchDevices, 800);
		this.lastComputedHeader = this.computedHeaders;
	},
	mounted() {
		document.addEventListener('click', this.closeDropdowns);
	},
	watch: {
		view(value) {
			store.set('prefered-devices-view', value);
			this.dropdowns.forEach(e => {
				e.value = false;
			});
		},
		computedHeaders(value) {
			if (this.view === 'list' && this.lastComputedHeader.length !== value.length) {
				let asd = [];
				this.dropdowns.forEach(e => {
					asd.push({ ID: e.ID, value: e.value });
					e.value = false;
				});
				this.lastComputedHeader = value;
				Vue.nextTick(() => {
					this.dropdowns = asd;
				});
			}
		}
	},
	data() {
		return {
			isScreenMonitoringEnabled: process.env.SCREEN_MONITORING === 'true',
			polling: null,
			view: 'grid',
			isCancelled: false,
			snack: {
				visible: false,
				message: '',
				color: '',
				timeout: 0
			},
			errorSnack: {
				visible: false,
				message: '',
				color: 'red',
				timeout: 6000
			},
			limitSnack: {
				visible: false,
				alreadyShowed: false
			},
			headers: [
				{ sortable: false, value: 'DisplayIcon' },
				{ text: 'Name', value: 'DisplayName' },
				{ text: 'Model', value: 'DeviceBrand' },
				{ text: 'Access level', value: 'AccessLevel' },
				{ text: 'Last activity', value: 'LastConnected' },
				{ text: 'Status', value: 'Online' },
				{ sortable: false, value: 'DropdownIcon' }
			],
			lastComputedHeader: null,
			selectedDevices: [],
			groupNames: [],
			dropdowns: [],
			savedGroupName: '',
			filter: '',
			onFilterInput: '',
			isSearching: false,
			isTyping: false,
			grid: {
				xl: 1820,
				lg: 1640,
				md: 1440,
				sm: 1280,
				xs: 1185,
				xxs: 1060,
				sd: 960
			},
			list: {
				xl: 1720,
				lg: 1450,
				md: 1100,
				sm: 850,
				xs: 500
			}
		};
	},
	computed: {
		devices() {
			this.$store.state.devices.items.forEach(x => {
				if (this.getDropdownindex(x.PublicID) === -1) {
					this.dropdowns.push({ ID: x.PublicID, value: false });
				}
			});
			if (this.isFilterUsed) {
				return this.$store.state.devices.items.filter(this.devicesFilter);
			}
			return this.$store.state.devices.items;
		},
		groups() {
			this.$store.state.devices.groups.forEach(x => {
				if (this.getIndex(x.ID) === -1) {
					let g = _.cloneDeep(x, true);
					g.Edited = false;
					this.groupNames.push(g);
				}
			});
			return this.$store.state.devices.groups;
		},
		shouldGroup() {
			if (this.groups.length > 0) {
				return 'stringGroupID';
			}
			return [];
		},
		isSetupDeviceRequired() {
			return (
				this.$store.state.devices.total === 0 &&
				!this.isFilterUsed &&
				this.$store.state.user.status !== 'cancelled'
			);
		},
		isFilterUsed() {
			if (this.filter === null) {
				return false;
			}
			return this.filter.length > 2;
		},
		currentFilter() {
			if (this.isFilterUsed) {
				return this.filter;
			}
			return '';
		},
		isDeviceLimitExceeded() {
			if (this.$store.state.devices.max === null || this.$store.state.devices.max === '-1') {
				return false;
			}
			let isExceeded = this.$store.state.devices.total > this.$store.state.devices.max;
			if (isExceeded && !this.limitSnack.alreadyShowed) {
				this.limitSnack.alreadyShowed = true;
				this.limitSnack.visible = true;
			}
			if (!isExceeded) {
				this.limitSnack.visible = false;
			}
			return isExceeded;
		},
		isPairingEnabled() {
			if (this.$store.state.devices.max === null || this.$store.state.devices.max === '-1') {
				return true;
			}
			return this.$store.state.devices.total < this.$store.state.devices.max;
		},
		showSwitcher() {
			return this.devices.length > 0 && this.selectedDevices.length === 0;
		},
		selectedDevicesID() {
			return this.selectedDevices.map(d => d.PublicID);
		},
		computedHeaders() {
			// Priority -> Name, status, device tipus, access level
			if (this.windowSize.width <= this.list.xs)
				return this.headers.filter(
					h => h.value !== 'DeviceBrand' && h.value !== 'DropdownIcon' && h.value !== 'DisplayIcon' && h.value !== 'AccessLevel' && h.value !== 'LastConnected'
				);
			else if (this.windowSize.width <= this.list.sm)
				return this.headers.filter(h => h.value !== 'DropdownIcon' && h.value !== 'DisplayIcon' && h.value !== 'AccessLevel' && h.value !== 'LastConnected');
			else if (this.windowSize.width <= this.list.md)
				return this.headers.filter(h => h.value !== 'DropdownIcon' && h.value !== 'DisplayIcon' && h.value !== 'AccessLevel' && h.value !== 'LastConnected');
			else if (this.windowSize.width <= this.list.lg) return this.headers.filter(h => h.value !== 'LastConnected');
			else return this.headers;
		},
		showSearch() {
			return this.$store.state.devices.total > 1;
		}
	},
	methods: {
		getIndex(groupID) {
			return this.groupNames.findIndex(i => i.ID === groupID);
		},
		getStringIndex(groupID) {
			return this.groupNames.findIndex(i => i.ID === Number(groupID.substr(1)));
		},
		getDropdownindex(publicID) {
			return this.dropdowns.findIndex(i => i.ID === publicID);
		},
		sortedDevices(items, sortBy, isDesc) {
			let sortDesc = isDesc[0];
			if (sortDesc === undefined) {
				sortDesc = false;
			}
			if (sortBy.length === 1) {
				sortBy = ['stringGroupID'].concat(sortBy);
			}
			if (sortBy.includes('Online')) {
				sortDesc = !sortDesc;
			}
			if (sortBy.includes('AccessLevel')) {
				return _.orderBy(
					items,
					[
						'stringGroupID',
						function (device) {
							if (!device) return '';

							let accessLevel = '';
							if (device.Build.FlavorGlobal === 'systemsigned') {
								accessLevel = 'Signed APK';
							} else if (device.Rooted) {
								accessLevel = 'Rooted';
							}

							return accessLevel;
						}
					],
					['desc', sortDesc ? 'desc' : 'asc']
				);
			}
			return _.orderBy(items, sortBy, ['desc', sortDesc ? 'desc' : 'asc']);
		},
		redirectToDevice(device, page) {
			if (this.isDeviceLimitExceeded) {
				this.$router.push({ name: 'device-limit-exceeded' });
			} else {
				if (page === undefined) {
					window.location = `/mgm?publicid=${device.PublicID}`;
				} else {
					window.open(`/mgm?publicid=${device.PublicID}&page=${page}`);
				}
			}
		},
		getLink(device) {
			if (this.isDeviceLimitExceeded) {
				return '/dashboard/device-limit-exceeded';
			}
			return `/mgm?publicid=${device.PublicID}`;
		},
		addSelectedDevicesToGroup(groupID) {
			this.addDevicesToGroup(groupID, this.selectedDevicesID);
		},
		addDevicesToGroup(groupID, devices) {
			this.dropdowns.forEach(x => {
				x.value = false;
			});
			DeviceService.addDevicesToGroup(groupID, devices)
				.then(response => {
					this.selectedDevices = [];
					this.$store.dispatch('updateDevices', {
						search: this.isBackendSearchUsed ? this.currentFilter : '',
						force: true
					});
				})
				.catch(error => {
					this.errorSnack.message = 'Something went wrong (Error 500)<br>Please try again';
					this.errorSnack.visible = true;
				});
		},
		saveOldGroupName(groupID) {
			this.savedGroupName = _.cloneDeep(this.groupNames[this.getStringIndex(groupID)].Name, true);
		},
		saveGroupName(groupID) {
			DeviceService.updateGroup(Number(groupID.substr(1)), this.groupNames[this.getStringIndex(groupID)].Name)
				.then(response => {
					this.savedGroupName = _.cloneDeep(this.groupNames[this.getStringIndex(groupID)].Name, true);
					this.$store.dispatch('updateDevices', {
						search: this.isBackendSearchUsed ? this.currentFilter : '',
						force: true
					});
				})
				.catch(error => {
					if (error.response.status >= 400 && error.response.status < 500) {
						this.errorSnack.message = 'Invalid group name';
					} else {
						this.errorSnack.message = 'Rename failed, please try again';
					}
					this.errorSnack.visible = true;
				})
				.finally(() => {
					document.getElementById(groupID).blur();
					this.groupNames[this.getStringIndex(groupID)].Edited = false;
				});
		},
		discardGroupName(groupID) {
			this.groupNames[this.getStringIndex(groupID)].Name = this.savedGroupName;
			this.groupNames[this.getStringIndex(groupID)].Edited = false;
		},
		closeDropdowns(event) {
			if (event.target.localName !== 'body' && event.target.localName !== 'html') {
				return;
			}
			this.dropdowns.forEach(x => {
				x.value = false;
			});
		},
		onEdit(groupID) {
			this.groupNames[this.getStringIndex(groupID)].Edited = true;
			Vue.nextTick(() => {
				document.getElementById(groupID).focus();
			});
		},
		isDeviceSelected(device) {
			return this.selectedDevicesID.includes(device.PublicID);
		},
		getStringGroupID(groupID) {
			let g = 'g';
			return g + ('0000000000' + groupID).slice(-10);
		},
		haveNotGrouped() {
			return this.devices.map(e => e.stringGroupID).includes('g0000000000');
		},
		haveGroups() {
			return this.groups.length !== 0;
		},
		isGroupNotEmpty(groupID) {
			return this.devices.map(e => e.GroupID).includes(groupID);
		},
		devicesFilter(device) {
			const lowerCaseFilter = this.currentFilter.toLowerCase();
			let check =
				device.DisplayName.toLowerCase().includes(lowerCaseFilter) ||
				device.Serial.toLowerCase().includes(lowerCaseFilter) ||
				device.PublicID.toLowerCase().includes(lowerCaseFilter) ||
				device.DeviceBrand.toLowerCase().includes(lowerCaseFilter) ||
				device.DeviceModel.toLowerCase().includes(lowerCaseFilter);
			let group = this.$store.state.devices.groups.filter(x => x.ID === device.GroupID);
			if (group.length !== 1) {
				return check;
			}
			return check || group[0].Name.toLowerCase().includes(lowerCaseFilter);
		},
		setTypeing() {
			if (this.isBackendSearchUsed) {
				this.isTyping = true;
			}
		},
		searchDevices() {
			this.isTyping = false;
			if (this.isBackendSearchUsed) {
				this.isSearching = true;
				this.$store.dispatch('updateDevices', { search: this.currentFilter }).finally(() => {
					this.isSearching = false;
				});
			}
		},
		capitalize(string) {
			return (string || '').replace(/\b\w/g, l => l.toUpperCase());
		}
	},
	filters: {
		status(status) {
			return status ? `Online` : `Offline`;
		},
		lastActivity(datetime) {
			return datetime ? moment.unix(datetime).format('LLL') : `None`;
		},
		capitalize(string) {
			return this.capitalize(string);
		},
		truncate(text, length, suffix) {
			if (text.length > length) {
				return text.substring(0, length) + suffix;
			} else {
				return text;
			}
		},
		model(device) {
			if (this.windowSize.width < this.list.sm + 1) {
				return this.capitalize(device.DeviceBrand)
			}
			if (device.DeviceModel.startsWith(device.DeviceBrand) || device.DeviceModel.startsWith(this.capitalize(device.DeviceBrand))) {
				return device.DeviceModel;
			} else {
				return this.capitalize(device.DeviceBrand) + ' ' + device.DeviceModel;
			}
		}
	},
	beforeDestroy() {
		clearInterval(this.polling);
		document.removeEventListener('click', this.closeDropdowns);
	}
};



// WEBPACK FOOTER //
// ./app/components/devices/script.js